/**
 * Plan Generator CA brand wordmark.
 * Reference design (plangenerator.com.au) inspired:
 *   - "Plan Generator" set in display weight, dark navy
 *   - "CA" trailing in accent cobalt-blue
 *   - No flag (per user direction Dec 2025)
 *
 * Use as <BrandWordmark /> wherever the logo appears.
 */
const BrandWordmark = ({ size = "md", onClick, className = "" }) => {
  const sizes = {
    sm: { wrap: "text-base", letter: "text-base" },
    md: { wrap: "text-xl", letter: "text-xl" },
    lg: { wrap: "text-2xl", letter: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      onClick={onClick}
      className={`inline-flex items-baseline gap-1.5 font-display font-black tracking-tight text-foreground ${onClick ? "cursor-pointer" : ""} ${s.wrap} ${className}`}
      data-testid="brand-wordmark"
    >
      <span>Plan</span>
      <span>Generator</span>
      <span className={`font-display font-black text-accent ${s.letter}`}>CA</span>
    </div>
  );
};

export default BrandWordmark;
